
define('text!templates/modules/calendar/animated-session/exercise/exercise-duplicate-modal.html',[],function () { return '<div class="exercise-duplicate-body">\n    <p>{{modalSubtitle}}</p>\n    <div class="animation-list"></div>\n</div>\n';});

